<ng-container *ngLet="langChange$ | async">
  <ng-container *ngLet="currentCatalogVersions$ | async">
    <div class="table" [class.impaired-table]="isImpairedVersion" *ngLet="selectCatalogInfo$ | async as catalogInfo">
      <ng-container *ngLet="selectCatalog$ | async as catalog">
        <ng-container *ngLet="breakPointObserve$ | async">
          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.DATASET_ID' | translate }}:</div>
          <div class="column2">
            {{ catalog?.datasetId }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column gray-title">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.IDENTIFICATION_NUMBER' | translate }}:</div>
          <div class="column2">
            {{ catalog?.idNumber }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'OTHER.DATASET_NAME' | translate }}:</div>
          <div class="column2">
            {{ isRuLocale ? catalog?.catalogNameRu : catalog?.catalogNameEn }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.DATASET_DESCRIPTION' | translate }}:</div>
          <div class="column2">
            {{ isRuLocale ? catalogInfo?.accountingObject : catalogInfo?.accountingObjectEn }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.DATASET_OWNER' | translate }}:</div>
          <div class="column2">
            {{ isRuLocale ? catalogInfo?.oiv ?? catalog.nameOIV : catalogInfo?.oivEn ?? catalog.nameOIVEn }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.RESPONSIBLE_FOR_DATASET' | translate }}:</div>
          <div class="column2">
            {{
              isRuLocale
                ? catalogInfo?.responsiblePerson?.fio ?? catalogInfo?.responsiblePerson?.responsibleFio
                : catalogInfo?.responsiblePerson?.fioEn ?? catalogInfo?.responsiblePerson?.responsibleFioEn
            }}<br />
            {{ catalogInfo?.responsiblePerson?.email ?? catalogInfo?.responsiblePerson?.responsibleEmail }}<br />
            {{ catalogInfo?.responsiblePerson?.phone ?? catalogInfo?.responsiblePerson?.responsiblePhone }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.DATASET_URL' | translate }}:</div>
          <div class="column2">
            <a class="link-3" *ngIf="showActualVersion" [routerLink]="tableRoute" target="_blank" [queryParams]="tableRouteParams">{{
              'DATA.CATALOG_ITEMS_DATA.PASSPORT.LINK_LATEST_VERSION_DATASET' | translate
            }}</a>
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.DATA_FORMAT' | translate }}:</div>
          <div class="column2">JSON</div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.DESCRIPTION_DATASET_STRUCTURE' | translate }}:</div>
          <div class="column2">
            <a
              *ngIf="showActualVersion"
              (click)="saveJson(catalog?.id, catalog?.idNumber, catalog.actualVersionPassport, lastVersion?.versionNum, isDynamic)"
              class="link-3"
              >{{ 'structure-' }}{{ isDynamic ? 'dynamicdata' : catalog.actualVersionPassport
              }}{{ lastVersion?.versionNum ? '(v' + lastVersion?.versionNum + ')' : '' }}{{ '.json' }}</a
            >
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.FIRST_PUBLICATION_DATE' | translate }}:</div>
          <div class="column2">
            {{ catalog.firstPublication }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.DATE_LATEST_CHANGES' | translate }}:</div>
          <div class="column2">{{ catalog.actualReleasePassport }}</div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.DATA_UPDATE_RATE' | translate }}:</div>
          <div class="column2">
            {{ isRuLocale ? catalogInfo?.period ?? catalogInfo?.updatePeriod + ' сек.' : catalogInfo?.periodEn }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.CONTENT_LATEST_CHANGE' | translate }}:</div>
          <div class="column2">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.RELEASE' | translate }}</div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.RELEVANCE_DATE_DATASET' | translate }}:</div>
          <div class="column2">
            {{ catalog?.validDate }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.KEYWORDS' | translate }}:</div>
          <div class="column2">
            {{isRuLocale ?  catalogInfo?.keywords : catalogInfo?.keywordsEn }}
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.URL_DATASET_VERSION' | translate }}:</div>
          <div class="column2" *ngLet="currentCatalogFiles$ | async">
            <ng-container *ngFor="let file of downloadFiles; let i = index">
              <a
                *ngIf="i < 5"
                (click)="downloadFile(file.idFile, catalog?.catalogName + ' версия ' + file.versionNum + '.' + file.releaseNum)"
                class="link-3 pointer"
                rel="nofollow"
                >{{
                ('OTHER.VERSION' | translate) +' ' +
                    file.versionNum +
                    '.' +
                    file.releaseNum +
                    ' от ' +
                    file.releaseDate +
                (file.releaseStatus === actualRelease ? ' (' + ('OTHER.ACTUAL' | translate)+ ')' : '')
                }}</a
              >
              <br *ngIf="i < 5" />
            </ng-container>
            <a (click)="openHistoryList()" class="link-3 pointer" rel="nofollow" target="_blank">
              {{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.DATA_UPDATE_HISTORY' | translate }}...</a
            >
          </div>

          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.LINKS_DESCRIPTION_VERSION_STRUCTURE' | translate }}:</div>
          <div class="column2">
            <ng-container *ngFor="let version of uniqueVersions">
              <a
                class="link-3"
                [routerLink]="getJsonFileLink(version.catalogId, catalog?.idNumber, version.releaseDateFull, version.versionNum)"
                target="_blank"
              >
                {{ 'structure-' + version.releaseDateFull + '(v' + version.versionNum + ').json' }}
              </a>
              <br />
            </ng-container>
            <a
              *ngIf="isDynamic"
              class="link-3"
              [routerLink]="
                getJsonFileLink(catalog?.id, catalog?.idNumber, lastVersion?.releaseDateFull ?? catalog.defaultValidDate, lastVersion?.versionNum)
              "
              target="_blank"
              >{{ 'structure-dynamicdata.json' }}</a
            >
          </div>
          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.LINKS_FORUM' | translate }}:</div>
          <div class="column2">
            <a *ngIf="(catalog ?? catalogInfo)?.linkForum && (catalog ?? catalogInfo)?.linkForum != 'null'" [href]="(catalog ?? catalogInfo)?.linkForum" class="link-3" rel="nofollow" target="_blank">{{
              (catalog ?? catalogInfo)?.linkForum
            }}</a>

          </div>
          <div class="horizontal-line vl"></div>

          <div class="column">{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.VERSION_METHODOLOGICAL_GUIDELINES' | translate }}:</div>
          <div class="column2">
            <a href="https://op.mos.ru/MEDIA/getFile?id=997e6556-8790-4bb3-b674-ee024d4306ae"
               class="link-3"
               target="_self"
            >{{ 'DATA.CATALOG_ITEMS_DATA.PASSPORT.VERSION_METHODOLOGICAL_GUIDELINES_LINK' | translate }}</a>
          </div>
          <div class="horizontal-line vl"></div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
